// Ambient glowing orbs, pure CSS (no scroll listeners) so it never interferes
// with page scrolling. A slow drift keeps it feeling alive.
export const Background = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
  >
    <div className="orb orb-indigo absolute -top-40 -left-40 h-[42rem] w-[42rem] rounded-full bg-[#4f46e5] blur-[150px] opacity-40" />
    <div className="orb orb-violet absolute top-10 left-1/3 h-[34rem] w-[34rem] rounded-full bg-[#7c3aed] blur-[160px] opacity-30" />
    <div className="orb orb-peach absolute -top-24 -right-32 h-[38rem] w-[38rem] rounded-full bg-[#ffb7b2] blur-[150px] opacity-30" />
    <div className="orb orb-deep absolute bottom-0 left-1/4 h-[30rem] w-[30rem] rounded-full bg-[#4f46e5] blur-[170px] opacity-20" />
  </div>
);
